(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryDialogController', WarningCategoryDialogController);

    WarningCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'WarningCategory', '$state'];

    function WarningCategoryDialogController ($timeout, $scope, $stateParams, entity, WarningCategory, $state) {
        var vm = this;
        vm.warningCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:warningCategoryUpdate', result);
            vm.isSaving = false;
            $state.go('warning-category');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.warningCategory.id !== null) {
                WarningCategory.update(vm.warningCategory, onSaveSuccess, onSaveError);
            } else {
                WarningCategory.save(vm.warningCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('warning-category');
        };
    }
})();
